import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { GuidNameCode } from './guid-name-code.type';
import { HubLookup } from './hub-lookup.type';

const DivisionLookup = t.intersection(
  [
    GuidNameCode,
    t.type({
      hubs: nullable(t.array(HubLookup)),
    }),
  ],
  'DivisionLookup',
);

type DivisionLookup = t.TypeOf<typeof DivisionLookup>;
export { DivisionLookup };
